import { render, staticRenderFns } from "./respuestasGestion.vue?vue&type=template&id=e4dba2f4"
import script from "./respuestasGestion.vue?vue&type=script&lang=js"
export * from "./respuestasGestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports